import { useState } from "react";
import { SpeakerHigh, SpeakerSlash } from "@phosphor-icons/react";
import { soundOn, enableSound, disableSound, chime } from "@/lib/nowAlert";

export const ConsultNowSound = () => {
  const [on, setOn] = useState(soundOn());
  const toggle = () => {
    if (on) { disableSound(); setOn(false); } else { enableSound(); setOn(true); }
  };
  return (
    <div data-testid="consult-now-sound" className="mt-2 rounded-xl bg-white/70 p-2 text-[11px] text-slate-600">
      <div className="flex flex-wrap items-center gap-1.5">
        <button data-testid="consult-now-sound-toggle" onClick={toggle} className={`flex items-center gap-1 rounded-full px-3 py-1 font-bold ${on ? "bg-amber-600 text-white" : "bg-white text-amber-700 ring-1 ring-amber-300"}`}>
          {on ? <><SpeakerHigh size={12} weight="fill" /> Suara aktif — matikan</> : <><SpeakerSlash size={12} weight="fill" /> Aktifkan Suara</>}
        </button>
        <button data-testid="consult-now-sound-test" onClick={chime} className="rounded-full bg-white px-3 py-1 font-bold text-slate-600 ring-1 ring-slate-200">Tes Suara</button>
      </div>
      <p data-testid="consult-now-sound-note" className="mt-1 leading-snug">
        Suara hanya berbunyi selama aplikasi ini terbuka di browser. Setelah halaman dimuat ulang, klik di mana saja sekali agar browser mengizinkan suara.
        Bila halaman atau browser ditutup, tidak ada suara dari web — pesanan baru dikirim lewat WhatsApp.
      </p>
    </div>
  );
};
